export default "__VITE_ASSET__Cx16HKDU__"